export default __webpack_public_path__ + "static/Dekra_LP2_iPhoneLarge-49836c827bbd0a28b939266812d7e76b.png";